// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_q0-5";
export var filledCircle = "_q0-4";
export var historyEntry = "_q0-3";
export var messageSideLeft = "_q0-1";
export var messageSideRight = "_q0-2";
export var orderTrackingCarouselWrapper = "_q0-6";
export var orderTrackingInfoContainer = "_q0-0";